// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const Invite = () => {
  return (
    <div style={{ textAlign: "left", marginLeft: "40px" }}>
      <div style={{ fontSize: "28px", fontWeight: "500" }}>Invite A Friend</div>
      <div style={{ fontSize: "20px", opacity: 0.7, paddingTop: "20px" }}>Invite your friend to shop on Fraazo {"&"} get ₹100 off on purchased item</div>
      <div style={{ paddingTop:"40px" }}>
        <div style={{ width: "180px", fontSize: "18px", border: "1px solid #43c6ac", borderRadius: "50px", padding: "15px 25px", color:"#43c6ac",fontWeight:"500" }}>
        FRZ-5538237
        </div>
      </div>
      
    </div>
  )
}

export default Invite